<script setup>
import { defineProps } from "vue"
import { Picture } from '@element-plus/icons-vue'

// 接受父组件的数据
const props = defineProps(['address'])

</script>

<template>
  <el-image style="width: 160px; height: 100px;border: 1px solid #d9d9d9;" :src="props.address" :lazy=true alt="手持身份证" fit="scale-down" :preview-src-list="[props.address]" :hide-on-click-modal=true>
    <template #error>
      <div class="image-slot">
        <el-icon>
          <Picture />
        </el-icon>
        <span class="image-tit">加载失败</span>
      </div>
    </template>
  </el-image>
</template>

<style lang="less" scoped>
.image-slot {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: var(--el-fill-color-light);
  color: var(--el-text-color-secondary);
  font-size: 30px;

  .image-tit {
    font-size: 14px;
  }
}
</style>

